export default __webpack_public_path__ + "static/media/lr.f1dab847.svg";